import {ToastContainer} from 'react-toastify';
import {axiosInstance} from "../utilities/AxiosConfig";
import {useSpinner} from "../context/SpinnerContext";
import React, {useCallback, useEffect, useState} from "react";

import {Button} from 'primereact/button';
import dayjs from "dayjs";
import {ToMySqlDate} from "../utilities/ToMySqlDate";
import {Scanner} from "../components/Image/ImageUtils";
import {MunshiMenu} from "../components/Menu";
import {Card} from "primereact/card";
import {PickDate} from "../components/Select/DateSelect";
import {CustomerSelect} from "../components/Select/CustomerSelect";
import {DepartmentSelect} from "../components/Select/DepartmentSelect";
import {InputText} from "primereact/inputtext";
import {notify} from "../components/toast";
import {sF, sI} from "../utilities/NumberFormatter";

import {VoucherPrint} from "../print/voucherPrint";
import {InputNumber} from "primereact/inputnumber";
import {Auths} from "../utilities/getAuthDep";
import "./Voucher.css";

export function Voucher({handle}) {
    const [voucherId, setVoucherId] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [creditCustomer, setCreditCustomer] = useState({});
    const [debitCustomer, setDebitCustomer] = useState({});
    const [debitDep, setDebitDep] = useState({});
    const [creditDep, setCreditDep] = useState({});
    const [level] = useState(Auths);
    const [posted, setPosted] = useState(false);
    const [comment, setComment] = useState("");
    const [amount, setAmount] = useState(0);
    const [mounts, setMounts] = useState(false)
    const [showPrint, setShowPrint] = useState(false);
    const [customerList, setCustomerList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [bioData, setBioData] = useState({});


    const {loading, setLoading} = useSpinner()
        useEffect(() => {
            const fetchInitialData = async () => {
                setLoading(true);
                try {
                    // Fetch all data in parallel for better performance
                    const [bioRes,depRes, custRes] = await Promise.all([
                        axiosInstance.get('biodata/'),
                        axiosInstance.get('department'),
                        axiosInstance.get('customer')
                    ]);

                   setDepartmentList(depRes.data)
                    setBioData(bioRes.data);
                    setCustomerList(custRes.data);
                } catch (error) {
                    notify(error.message, "error");
                } finally {
                    setLoading(false);
                }
            };

            fetchInitialData();
        }, []);
    const resetVoucher = () => {
        setVoucherId(0)
        setCreditCustomer({id: 0, name: ""})
        setDebitCustomer({id: 0, name: ""})
        setDebitDep({id: 1, name: "ALL"})
        setCreditDep({id: 1, name: "ALL"})
        setPosted(false)
        setComment("")
        setAmount(0)
        setSelectedDate(new Date())
    }
    useEffect(() => {
        setMounts(false)
        if (voucherId === 0) {
            resetVoucher()
            setMounts(true)
        } else {
            setLoading(true)
            const url = "voucher/id/" + voucherId;
            const currentId = voucherId > 0 ? voucherId : 0;
            axiosInstance.get(url).then((response) => {
                if (!response || response.data.length === 0) {
                    resetVoucher()
                    setVoucherId(currentId)
                } else {
                    setDebitCustomer({id: sI(response.data.debitId), name: response.data.debitName})
                    setCreditCustomer({id: sI(response.data.creditId), name: response.data.creditName})
                    setDebitDep({id: sI(response.data.debitDepId), name: response.data.debitDepName})
                    setCreditDep({id: sI(response.data.creditDepId), name: response.data.creditDepName})
                    setPosted(response.data.posted)
                    setComment(response.data.comment)
                    setAmount(sF(response.data.amount))
                    setSelectedDate(new Date(response.data.date))
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(() => {
                setLoading(false)
                setMounts(true)
            })
        }
    }, [voucherId, setVoucherId])
    const setAction = (action) => {
        switch (action) {
            case "Back": {
                setMounts(false)
                if (voucherId > 1) {
                    setVoucherId(voucherId - 1)
                } else {
                    setLoading(true)
                    axiosInstance.get("voucher/maxId/").then((response) => {
                        if (voucherId > 1) {
                            setVoucherId(sI(response.data) - 1)
                        } else {
                            setVoucherId(sI(response.data))
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        () => {
                            setLoading(false)
                        }
                    )
                }
                break
            }
            case "Next": {
                setLoading(true)
                axiosInstance.get("voucher/maxId/").then((response) => {
                    if (voucherId === sI(response.data)) {
                        setVoucherId(0)
                    } else {
                        setVoucherId(voucherId + 1)
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )
                break
            }
            case "Print": {
                setShowPrint(true)
                break;
            }
            case "Delete": {
                setLoading(true)
                axiosInstance.delete(`voucher/${voucherId}`).then((response) => {
                    setVoucherId(0)
                    notify("Voucher Deleted Successfully", "success")
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )
                break;
            }
            case "Undo": {
                setVoucherId(0)
                break
            }
            case "Show": {
                setShowImage(true)
                break
            }
            case "Post": {
                if (!level.posting()) {
                    notify("You are not allowed to post voucher", "error")
                    return
                }
                setLoading(true)
                axiosInstance.get(`voucher/post/id/${voucherId}`).then((response) => {
                    setPosted(true)
                    notify("Voucher Posted Successfully", "success")
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )
                break;
            }
            case "Unpost": {
                if (!level.posting()) {
                    notify("You are not allowed to un-post voucher", "error")
                    return
                }
                setLoading(true)
                axiosInstance.get(`voucher/unpost/id/${voucherId}`).then((response) => {
                    setPosted(false)
                    notify("Voucher UnPosted Successfully", "success")
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )
                break;
            }
            case "Save": {
                setLoading(true)
                axiosInstance.post(`voucher/`, {
                    id: voucherId,
                    debitId: debitCustomer.id,
                    creditId: creditCustomer.id,
                    debitName: debitCustomer.name,
                    creditName: creditCustomer.name,
                    debitDepId: debitDep.id,
                    creditDepId: creditDep.id,
                    creditDepName: creditDep.name,
                    debitDepName: debitDep.name,
                    amount: sF(amount),
                    date: ToMySqlDate(dayjs(selectedDate)),
                    comment: comment,
                    posted: posted,
                }).then((response) => {
                    setVoucherId(response.data)
                    notify("Voucher Saved Successfully", "success")
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )
                break;
            }
            default:
                notify("Action not implemented", "error")
                break;
        }
    }


    const handleCreditCustomer = useCallback((customer) => {
        setCreditCustomer(customer)
    }, [setCreditCustomer])
    const handleDebitCustomer = useCallback((customer) => {
        setDebitCustomer(customer)
    }, [setDebitCustomer])
    const handleCreditDep = useCallback((department) => {
        setCreditDep(department)
    }, [setCreditDep])
    const handleDebitDep = useCallback((department) => {
        setDebitDep(department)
    }, [setDebitDep])
    const handleComment = useCallback((c) => {
        setComment(c)
    }, [setComment])
    const handleAmount = useCallback((e) => {
        setAmount(e.value)
    }, [setAmount])
    const handleDate = useCallback((date) => {
        setSelectedDate(date)
    }, [setSelectedDate])

    const footer = (
        <>
            <div className="container flex justify-content-center">
                <Button label="Previous" icon="pi pi-step-backward mr-1" onClick={() => setAction("Back")}
                        disabled={voucherId === 1}/>
                <Button icon="pi pi-print" className="mr-1" onClick={() => setAction("Print")}
                        disabled={voucherId === 0}/>
                <Button icon="pi pi-trash" className="mr-1" onClick={() => setAction("Delete")}
                        disabled={(voucherId === 0 || posted)}/>
                <Button icon="pi pi-undo" className="mr-1" onClick={() => setAction("Undo")}
                        disabled={false}/>
                <Button icon="pi pi-thumbs-up" className="mr-1" onClick={() => setAction("Post")}
                        disabled={posted || voucherId === 0 || !level.posting()}/>
                <Button icon="pi pi-thumbs-down" className="mr-1" onClick={() => setAction("Unpost")}
                        disabled={!posted || voucherId === 0 || !level.posting()}/>
                <Button icon="pi pi-save" className="mr-1" onClick={() => setAction("Save")}
                        disabled={posted || creditCustomer.id === 0 || debitCustomer.id === 0}/>
                <Button type="button" icon="pi pi-image" disabled={!posted} onClick={() => setAction("Show")}/>
                <Button label="Next" icon="pi pi-step-forward" onClick={() => setAction("Next")}
                        disabled={voucherId === 0}/>
            </div>
        </>
    );
    if (showPrint) {
        const dt = ToMySqlDate(dayjs(selectedDate))
        const am = sF(amount)
        const data = {
            id: voucherId,
            debitId: debitCustomer.id,
            creditId: creditCustomer.id,
            debitName: debitCustomer.name,
            creditName: creditCustomer.name,
            debitDepId: debitDep.id,
            creditDepId: creditDep.id,
            creditDepName: creditDep.name,
            debitDepName: debitDep.name,
            amount: am,
            date: dt
        }
        return (
            <>
                <VoucherPrint data={data} setPrint={setShowPrint} companyName={bioData.name}/>
            </>
        )
    } else if (!loading) {
        return (
            <div className="voucher-page">
                <ToastContainer/>
                {showImage ?
                    <Scanner loading={loading} setLoading={setLoading} invoice={voucherId} mode={"VOUC"}
                             showImage={showImage} setShowImage={setShowImage}/> : null}
                <MunshiMenu handle={handle}/>
                <div className="container card flex flex-wrap justify-content-center w-auto m-5 mt-0 voucher-shell">
                    <Card title="Voucher" footer={footer}
                          className="flex align-items-center justify-content-center voucher-card">
                        {(mounts && !loading) &&
                            <div className="container card flex flex-column justify-content-center align-content-center voucher-form">
                                <table className="table  voucher-table">
                                    <tbody>
                                    <tr>
                                        <th >Voucher No :</th>
                                        <td>
                                            <div className="flex gap-2">
                                                <InputNumber
                                                    value={voucherId}
                                                    onValueChange={(e) => setVoucherId(e.value || 0)}
                                                    useGrouping={false}
                                                    placeholder="Search ID..."
                                                    onFocus={(e) => e.target.select()}
                                                    className="h-2rem voucher-input"
                                                    size={10}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setVoucherId(e.target.value);
                                                        }
                                                    }}
                                                />
                                                <Button
                                                    icon="pi pi-search"
                                                    className="h-2rem w-2rem voucher-btn"
                                                    onClick={() => setVoucherId(voucherId)}
                                                    tooltip="Load Voucher"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Date :</th>
                                        <td>{!loading && selectedDate && mounts &&
                                            <PickDate iDate={selectedDate} setDate={handleDate} disable={posted}/>}</td>
                                    </tr>
                                    <tr>
                                        <th>Debit Customer :</th>
                                        {!loading && debitCustomer &&
                                            <td><CustomerSelect customer={debitCustomer} disable={posted}
                                                                setCustomer={handleDebitCustomer}
                                                                customerList={customerList}/></td>}
                                    </tr>
                                    <tr>
                                        <th>Debit Department :</th>
                                        {!loading && debitDep &&
                                            <td>
                                                <DepartmentSelect disable={posted} department={debitDep}
                                                                  setDepartment={handleDebitDep}
                                                                  departmentList={departmentList}/></td>}
                                    </tr>
                                    <tr>
                                        <th>Credit Customer :</th>
                                        {!loading && creditCustomer && mounts &&
                                            <td><CustomerSelect customer={creditCustomer} disable={posted}
                                                                setCustomer={handleCreditCustomer}
                                                                customerList={customerList}/></td>}
                                    </tr>
                                    <tr>
                                        <th>Credit Department :</th>
                                        {!loading && creditDep && mounts &&
                                            <td><DepartmentSelect disable={posted} department={creditDep}
                                                                  setDepartment={handleCreditDep}
                                                                  departmentList={departmentList}/></td>}
                                    </tr>
                                    <tr>
                                        <th>Amount :</th>
                                        {!loading && mounts &&
                                            <td><InputNumber onKeyDown={(e)=>{
                                                                 if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                                     e.preventDefault();
                                                                 }
                                                             }}
                                                             disabled={posted}
                                                             onFocus={(e) => e.target.select()}
                                                             value={sF(amount)}
                                                             max={1000000000}
                                                             onValueChange={handleAmount}
                                                             minFractionDigits={2}
                                                             size={16}
                                                             className="w-full h-2rem voucher-input"
                                            /></td>}
                                    </tr>
                                    <tr>
                                        <th>Comment :</th>
                                        {!loading && mounts &&
                                            <td><InputText className="w-full flex align-items-center h-2rem voucher-input"
                                                           value={comment}
                                                           onChange={(e) => handleComment(e.target.value)}
                                                           disabled={posted}
                                            /></td>}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>}
                    </Card>
                </div>
            </div>
        );
    }
}


export default Voucher;

